export class OperationTestnameresponse{
    testName:string
    testResultId:number
    constructor(testName:string,testResultId:number){

        this.testName=testName;
        this.testResultId=testResultId;
    }
}